import { render, staticRenderFns } from "./SettingsVpnServers.vue?vue&type=template&id=5dccaf0e"
import script from "./SettingsVpnServers.vue?vue&type=script&lang=js"
export * from "./SettingsVpnServers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports